import React from 'react'

const Media = () => {
    return (
        <div className="p-4">Media Content</div>
    )
}

export default Media
